<template>
  <div class="relative flat">
    <div class="flat__plans flat-plans desktop-only">
      <div class="flat-plans__row">
        <div class="flat-plans__image _buildings" v-show="step === 0">
          <div v-if="!isMobile" class="buildings-choose" id="buildings-container" ref="buildings-container"></div>
        </div>
        <div class="flat-plans__image _building relative" v-if="step === 1">
          <div v-if="!isMobile" class="buildings-choose" id="building-container" ref="building-container"></div>
          <div class="flat-plans-description absolute flex flex-col items-center"
               v-if="hoveredBuildingFloor">
                    <span
                      class="flat-plans-description__text _uppercase text _x-bold">{{ hoveredBuildingFloor.number }} этаж</span>
            <span
              class="flat-plans-description__text _uppercase text _x-bold">{{
                            hoveredBuildingFloor.available_apartments
                        }}&nbsp;{{
                            pluralOfNum(hoveredBuildingFloor.available_apartments, ['квартира', 'квартиры', 'квартир'])
                        }}</span>
          </div>
        </div>
        <div class="flat-plans__image _flats-plan" v-if="step === 2">
          <div v-if="!isMobile" id="floor-plan" class="buildings-choose" ref="floor-plan"></div>
        </div>
        <div class="flat-plans__image _scheme flex flex-col justify-end items-end align-self-end">
          <div class="flat-plans__image _building-small relative" v-if="step === 2">
            <div class="col flex-col">
              <div class="desktop-only rose">
                <!-- <img src="/images/purchase/rose.svg"  alt=""> -->
                <img v-if="selectedBuilding.number===1" src="/images/purchase/rose-1.svg"  alt="">
                <img v-if="selectedBuilding.number===2" src="/images/purchase/rose-2.svg"  alt="">
                <img v-if="selectedBuilding.number===3" src="/images/purchase/rose-3.svg"  alt="">
                <img v-if="selectedBuilding.number===4" src="/images/purchase/rose-4.svg"  alt="">
                <!-- <img v-if="typeof(selectedBuilding.number)!==number" src="/images/purchase/rose-all.svg" alt=""> -->
              </div>
              <div class="buildings-choose" id="small-building-container" ref="small-building-container"></div>
            </div>
            <div class="flex flex-col items-center absolute flat-control">
              <button @click="btnChangeFloor('up')" class="flat-scheme__control _up">
                <svg>
                  <use xlink:href="../../../images/sprite.svg#bird-arrow"/>
                </svg>
              </button>
              <div class="flat-scheme__floor flat-scheme-floor flex flex-col items-center">
                <div class="flat-scheme-floor__number">{{ selectedBuildingFloor.number }}</div>
                <span class="flat-scheme-floor__text text">этаж</span>
              </div>
              <button @click="btnChangeFloor('down')" class="flat-scheme__control _down">
                <svg>
                  <use xlink:href="../../../images/sprite.svg#bird-arrow"/>
                </svg>
              </button>
            </div>
          </div>
          <div
            class="flex flex-col items-center flat-plans__image _buildings-small" v-if="step !== 0">
            <div v-if="!isMobile && step !== 2" class="buildings-choose" id="small-buildings-container" ref="small-buildings-container"></div>
            <span class="text" v-if="step !== 2">Корпус №{{ selectedBuilding.number }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="flat__detailed flat-detailed" :class="{'last-step':step===2}">
      <h1 class="text title _x-bold flat-detailed__title">Выбор квартиры</h1>
      <router-link
        tag="button"
        to='/choice-of-apartment'
        class="flat-detailed__plan cursor-pointer flex items-center justify-center brown-btn"
      >
        <span>Выбрать по параметрам</span>
        <svg class="flat-choose__icon _white ml-1 arrow-icon">
          <use xlink:href="../../../images/sprite.svg#flat-arrow-white"/>
        </svg>
      </router-link>
      <swiper class="swiper flat-detailed__menu flat-menu space-between mobile-only" :options="swiperOption" @click-slide="clickSlide" ref="swiper">
        <swiper-slide :class="{'_active':step === 0}">Шаг №1. Корпус</swiper-slide>
        <swiper-slide :class="{'_active':step === 1}">Шаг №2. Этаж</swiper-slide>
        <swiper-slide :class="{'_active':step === 2}">Шаг №3. Квартира</swiper-slide>
      </swiper>
      <ul class="flat-detailed__menu flat-menu space-between desktop-only" :class="{'w-50':step===2}">
        <li :class="{'_active':step === item.id, '_hidden-mobile':hidden === item.id}"
                      :key="item.id"
                      class="flat-menu__item _uppercase cursor-pointer"
                      v-for="item in menu"
                      @click="clickSlide(item.id)"
        >{{ item.text }}
        </li>
      </ul>
      <div class="flat-detailed__step" v-show="step === 0">
        <div class="flat-detailed__buildings-big mobile-only">
          <div v-if="isMobile" class="buildings-choose" id="buildings-container" ref="buildings-container"></div>
        </div>
        <h2 class="flat-detailed__subtitle _uppercase desktop-only">Выберите корпус на схеме</h2>
<!--        <h2 class="flat-detailed__subtitle _uppercase" v-else>Выберите корпус</h2>-->
        <div class="flat-detailed__buildings-small mobile-only mb-5">
          <picture>
            <img src="/images/purchase/rose-horiz-all-active.svg" alt="">
          </picture>
        </div>
          <!-- <picture>
            <source type="image/webp" media="(min-width: 1024px)" srcset="/images/purchase/scheme-desktop-coloured@2x.webp">
            <source media="(min-width: 1024px)" srcset="/images/purchase/scheme-desktop-coloured@2x.jpg">
            <img class="flat-detailed__scheme-coloured desktop-only" src="/images/purchase/scheme-desktop-coloured.jpg" srcset="/images/purchase/scheme-desktop-coloured@2x.jpg 2x" alt="">
          </picture> -->
          <picture>
            <!-- <img class="flat-detailed__scheme-coloured desktop-only" src="/images/purchase/rose-horiz-2.svg" alt=""> -->
            <img class="flat-detailed__scheme-coloured desktop-only" src="/images/purchase/rose-horiz-all-active.svg" alt="">


            <!-- <img class="flat-detailed__scheme-coloured" src="/images/purchase/rose-horiz-all-active.svg" alt=""> -->
          </picture>

        <!--  TEMPORARILY COMMENTED - MIGHT BE NEEDED LATER      -->
<!--        <div class="flat-detailed__available _uppercase text" v-if="selectedBuildingAvailableApartments">В-->
<!--          наличии-->
<!--        </div>-->
<!--        <div class="flat-options" v-if="selectedBuildingAvailableApartments">-->
<!--          <div class="flex items-center flat-options__heading flat-options-heading">-->
<!--            <span class="flat-options-heading__text _first">№</span>-->
<!--            <span class="flat-options-heading__text">Спален</span>-->
<!--            <span class="flat-options-heading__text">Площадь</span>-->
<!--          </div>-->
<!--          <div class="flex items-center flat-options__row flat-options-row"-->
<!--               v-for="apartment in selectedBuildingAvailableApartments">-->
<!--            <span class="flat-options-row__text _floor">{{ apartment.number }}</span>-->
<!--            <span class="flat-options-row__text _rooms">{{ apartment.bedrooms }}</span>-->
<!--            <span class="flat-options-row__text _area">{{ apartment.area }} м<sup>2</sup></span>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="flat-detailed__step _second" v-if="step === 1">
        <div class="flat-detailed__overview flat-overview flex space-between mobile-only">
          <div class="flat-overview__building relative">
            <div v-if="isMobile" class="buildings-choose" id="building-container" ref="building-container"></div>
<!--            <div v-if="selectedBuildingFloor"-->
<!--              class="flat-overview__description flat-overview-description flex flex-col items-center absolute">-->
<!--              <span class="flat-overview-description__text _uppercase text">{{ selectedBuildingFloor.number }} этаж</span>-->
<!--              <span class="flat-overview-description__text _uppercase text">{{-->
<!--                  selectedBuildingFloor.available_apartments-->
<!--                }}&nbsp;{{-->
<!--                  pluralOfNum(selectedBuildingFloor.available_apartments, ['квартира', 'квартиры', 'квартир'])-->
<!--                }}</span>-->
<!--            </div>-->
          </div>
          <div class="flex flex-col">
            <div class="flat-overview__buildings flat-overview-buildings flex flex-col space-between">
              <div class="flex flex-col items-center mb-3" v-if="isMobile">
                <button @click="btnChangeFloor('up')" class="flat-scheme__control _up">
                  <svg>
                    <use xlink:href="../../../images/sprite.svg#bird-arrow"/>
                  </svg>
                </button>
                <div class="flat-scheme__floor flat-scheme-floor flex flex-col items-center">
                  <div class="flat-scheme-floor__number">{{ selectedBuildingFloor ? selectedBuildingFloor.number : chooseRandomFloor() }}</div>
                  <span class="flat-scheme-floor__text text">этаж</span>
                </div>
                <button @click="btnChangeFloor('down')" class="flat-scheme__control _down">
                  <svg>
                    <use xlink:href="../../../images/sprite.svg#bird-arrow"/>
                  </svg>
                </button>
              </div>
              <div v-if="isMobile" class="buildings-choose" id="small-buildings-container" ref="small-buildings-container"></div>
              <span
                class="flat-overview-buildings__text text">Корпус №{{ selectedBuilding.number }} </span>
            </div>
          </div>
        </div>
        <div class="flex items-center flat-overview-buildings__choose-item desktop-only" @click="step--">
          <svg class="mr-2">
            <use xlink:href="../../../images/sprite.svg#flat-arrow-black"/>
          </svg>
          <h2 class="flat-detailed__subtitle _uppercase _multiple">Корпус №{{ selectedBuilding.number }} - Выберите этаж</h2>
        </div>
<!--        <h2 class="flat-detailed__subtitle _uppercase _multiple _floor desktop-only" v-if="selectedBuildingFloor">-->
<!--          {{ selectedBuildingFloor.number }} этаж</h2>-->
        <div class="mr-1">
          <!-- <picture>
            <source type="image/webp" media="(min-width: 1024px)" srcset="/images/purchase/scheme-desktop-coloured@2x.webp">
            <source type="image/webp" srcset="/images/purchase/scheme-mobile.webp 1x, /images/purchase/scheme-desktop-coloured@2x.webp 2x">
            <source media="(min-width: 1024px)" srcset="/images/purchase/scheme-desktop-coloured@2x.jpg">
            <img class="flat-detailed__scheme-coloured" src="/images/purchase/scheme-mobile.jpg" srcset="/images/purchase/scheme-desktop-coloured@2x.jpg 2x" alt="">
          </picture> -->
          <picture>
              <img v-if="selectedBuilding.number===1" class="flat-detailed__scheme-coloured" src="/images/purchase/rose-horiz-1.svg" alt="">
              <img v-if="selectedBuilding.number===2" class="flat-detailed__scheme-coloured" src="/images/purchase/rose-horiz-2.svg" alt="">
              <img v-if="selectedBuilding.number===3" class="flat-detailed__scheme-coloured" src="/images/purchase/rose-horiz-3.svg" alt="">
              <img v-if="selectedBuilding.number===4" class="flat-detailed__scheme-coloured" src="/images/purchase/rose-horiz-4.svg" alt="">
          </picture>
        </div>

        <!--  TEMPORARILY COMMENTED - MIGHT BE NEEDED LATER      -->

<!--        <div class="flat-detailed__available _uppercase text" v-if="selectedBuildingFloor">В наличии: <span-->
<!--          class="_hypertext">{{-->
<!--                        selectedBuildingFloor.available_apartments-->
<!--                    }}&nbsp;{{-->
<!--                        pluralOfNum(selectedBuildingFloor.available_apartments, ['квартира', 'квартиры', 'квартир'])-->
<!--                    }}</span>-->
<!--        </div>-->
<!--        <div class="flat-options"-->
<!--             v-if="selectedFloorAvailableApartments && selectedFloorAvailableApartments.length > 0">-->
<!--          <div class="flex items-center flat-options__heading flat-options-heading">-->
<!--            <span class="flat-options-heading__text _first">№</span>-->
<!--            <span class="flat-options-heading__text">Спален</span>-->
<!--            <span class="flat-options-heading__text">Площадь</span>-->
<!--          </div>-->
<!--          <div class="flex items-center flat-options__row flat-options-row"-->
<!--               v-for="apartment in selectedFloorAvailableApartments">-->
<!--            <span class="flat-options-row__text _floor">{{ apartment.number }}</span>-->
<!--            <span class="flat-options-row__text _rooms">{{ apartment.bedrooms }}</span>-->
<!--            <span class="flat-options-row__text _area">{{ apartment.area }} м<sup>2</sup></span>-->
<!--          </div>-->
<!--        </div>-->

      </div>
      <div class="flat-detailed__step _third" v-if="step === 2">
        <div class="flat-detailed__scheme flat-scheme flex items-center space-between mobile-only">
          <div class="flat-scheme__floor">
            <div v-if="isMobile" id="floor-plan" class="buildings-choose" ref="floor-plan"></div>
          </div>
          <div class="flex flex-col items-center">
            <div class="flex flex-col items-center">
              <button @click="btnChangeFloor('up')" class="flat-scheme__control _up">
                <svg>
                  <use xlink:href="../../../images/sprite.svg#bird-arrow"/>
                </svg>
              </button>
              <div class="flat-scheme__floor flat-scheme-floor flex flex-col items-center">
                <div class="flat-scheme-floor__number">{{ selectedBuildingFloor.number }}</div>
                <span class="flat-scheme-floor__text text">этаж</span>
              </div>
              <button @click="btnChangeFloor('down')" class="flat-scheme__control _down">
                <svg>
                  <use xlink:href="../../../images/sprite.svg#bird-arrow"/>
                </svg>
              </button>
            </div>
            <div class="flat-overview__buildings flat-overview-buildings flex flex-col items-center">
              <div v-if="isMobile" class="buildings-choose" id="small-buildings-container" ref="small-buildings-container"></div>
              <span
                class="flat-overview-buildings__text text">Корпус №{{ selectedBuilding.number }}</span>
            </div>
          </div>
        </div>
        <div class="flex items-center flat-overview-buildings__choose-item _flat" @click="clickSlide(1)">
          <svg class="mr-2 desktop-only">
            <use xlink:href="../../../images/sprite.svg#flat-arrow-black"/>
          </svg>
          <h2 class="flat-detailed__subtitle _uppercase _multiple">Корпус №{{ selectedBuilding.number }} <span class="desktop-only">-</span> <br class="mobile-only"/> {{ selectedBuildingFloor.number }} этаж</h2>
        </div>
<!--        <h2 class="flat-detailed__subtitle _uppercase _multiple">Корпус №{{ selectedBuilding.number }}</h2>-->
<!--        <h2 class="flat-detailed__subtitle _uppercase _multiple">{{ selectedBuildingFloor.number }}&nbsp;этаж&nbsp;&mdash;-->
        <div class="flat-detailed__available _uppercase"> В наличии: <span class="_hypertext">{{ selectedBuildingFloor.available_apartments }}&nbsp;{{
          pluralOfNum(selectedBuildingFloor.available_apartments, ['квартира', 'квартиры', 'квартир']) }}</span></div>
        <template v-if="selectedFloorAvailableApartments">
<!--          <h2 class="flat-detailed__subtitle _uppercase _multiple _flat">Квартира №{{selectedApartment.number}}</h2>-->
<!--          <div class="flat-detailed__description flat-detailed-description flex flex-col">-->
<!--            <div class="flat-detailed-description__point">2-х комнатная квартира</div>-->
<!--            <div class="flat-detailed-description__point">C панорамным видом</div>-->
<!--          </div>-->
          <div class="flat-options js-flat-options" v-scroll="attachHeader">
            <div class="flex items-center flat-options__heading flat-options-heading js-flats-heading">
              <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'building_number' && sortOrder === 'desc', asc: orderBy === 'building_number' && sortOrder === 'asc' }" @click="sortBy('building_number')">Корпус</span>
              <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'floor_number' && sortOrder === 'desc', asc: orderBy === 'floor_number' && sortOrder === 'asc' }" @click="sortBy('floor_number')">Этаж</span>
              <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'bedrooms' && sortOrder === 'desc', asc: orderBy === 'bedrooms' && sortOrder === 'asc' }" @click="sortBy('bedrooms')">Комнаты</span>
              <span class="flat-options-heading__text" v-bind:class="{desc: orderBy === 'area' && sortOrder === 'desc', asc: orderBy === 'area' && sortOrder === 'asc' }" @click="sortBy('area')">Площадь</span>
              <span class="flat-options-heading__text _price" v-bind:class="{desc: orderBy === 'price' && sortOrder === 'desc', asc: orderBy === 'price' && sortOrder === 'asc' }" @click="sortBy('price')">Стоимость</span>
              <span class="flat-options-heading__text _uppercase _fw-800 _invisible desktop-only" style="padding-left: 2.5rem">Подробнее</span>
              <span class="flat-options-heading__text _uppercase _fw-800 _invisible mobile-only" style="padding-left: 4rem">
                <svg class="flat-choose__icon _arrow">
                    <use xlink:href="../../../images/sprite.svg#flat-arrow"/>
                </svg>
              </span>

            </div>
            <router-link
              tag="div"
              :to="'/choice-of-apartment/selected/' + flat.id"
              class="flex items-end flat-options__row flat-options-row cursor-pointer"
              v-for="flat in selectedFloorAvailableApartments"
              :key="flat.id"
            >
              <span class="flat-options-row__text _building">{{flat.building_number}}</span>
              <span class="flat-options-row__text _floor">{{flat.floor_number}}</span>
              <span class="flat-options-row__text _rooms">{{flat.bedrooms}}</span>
              <span class="flat-options-row__text _area">{{flat.area}} м<sup>2</sup></span>
              <span class="flat-options-row__text _price">{{flat.price.toString().indexOf('.') > -1 ? flat.price.split('.')[0] : flat.price}} руб.</span>
              <span class="flat-options-row__text _more desktop-only">Подробнее</span>
              <span class="flat-options-row__text _arrow mobile-only">
                <svg class="flat-choose__icon _arrow">
                    <use xlink:href="../../../images/sprite.svg#flat-arrow"/>
                </svg>
              </span>
              <!--                <span class="flat-options-row__text _special" v-if="flat.special">акция</span>-->
              <!--                <span class="flat-options-row__text _special" v-if="!flat.special"></span>-->
            </router-link>
          </div>
        </template>
      </div>
      <button @click="clickSlide(1)"
              class="back-btn flex items-center justify-center _uppercase mobile-only ml-3"
              v-if="step === 2">
        <svg class="mr-2">
          <use xlink:href="../../../images/sprite.svg#flat-arrow-black"/>
        </svg>
        <span>Назад</span>
      </button>
    </div>
  </div>
</template>
<script>
  import * as d3 from 'd3';
  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  // import 'swiper/css/swiper.css'
  import domtoimage from 'dom-to-image';


  export default {
    components: {
      Swiper,
      SwiperSlide
    },
    data() {
      return {
        step: 0, // current step
        buildings: [], // data from API

        orderBy: 'area',
        sortOrder: 'asc',

        floorChangeEvent: true,

        // SVG shit
        svgBuildingsContainer: null,
        svgBuildings: null,

        svgSmallBuildingsContainer: null,
        svgSmallBuildings: null,

        svgSmallBuildingWithFloorsContainer: null,
        svgSmallBuildingWithFloors: null,

        svgFloorPlanContainer: null, // TODO: implement this
        svgFloorPlan: null, // TODO: implement this

        svgCurrentBuildingContainer: null,
        svgCurrentBuilding: null,

        selectedBuilding: null, // current selected building
        selectedBuildingFloor: null, // current selected floor
        selectedApartment: null, // TODO: implement this (current selected apartment)

        hoveredBuildingFloor: null,


        swiperOption: {
          slidesPerView: 2,
          mousewheel: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },

        hidden: 2,
        menu: [
          {
            id: 0,
            text: 'Шаг №1. Корпус',
          },
          {
            id: 1,
            text: 'Шаг №2. Этаж',
          },
          {
            id: 2,
            text: 'Шаг №3. Квартира',
          }
        ],
        availableFlatOptions: [
          {
            flats: 15,
            number: 2,
            area: '78-140'
          }
        ],
      }
    },
    async mounted() {
      await axios.get('/buildings').then(response => {
        this.buildings = response.data.data
      }, this)
      await this.addBuildings('/images/purchase/buildings.svg');
      this.fetchLocationParams();
      let that = this;
      window.onpopstate = function(event) {
        setTimeout(() => {
          that.$router.go();
        },200)
      };
    },
    watch: {
      // step() { // in future to not set 3 step on mobile if btn does btn clicked
      //     console.log('step', this.step);
      // }
      // '$route.query' (to, from) {
      //   this.fetchLocationParams()
      //   this.$forceUpdate()
      // }
    },
    methods: {
      sortBy(sortingName){
        this.showLoader = true
        switch (sortingName) {
          case 'building_number':
             if(this.sortOrder === 'asc'){
              sorting('building_number','desc',this)
            }else{
              sorting('building_number','asc',this)
            }
            break;
          case 'floor_number':
            if(this.sortOrder === 'asc'){
              sorting('floor_number','desc',this)
            }else{
              sorting('floor_number','asc',this)
            }
            break;
          case 'bedrooms':
            if(this.sortOrder === 'asc'){
              sorting('bedrooms','desc',this)
            }else{
              sorting('bedrooms','asc',this)
            }
            break;
          case 'area':
            if(this.sortOrder === 'asc'){
              sorting('area','desc',this)
            }else{
              sorting('area','asc',this)
            }
            break;
          case 'price':
            if(this.sortOrder === 'asc'){
              sorting('price','desc',this)
            }else{
              sorting('price','asc',this)
            }
            break;
        }

        function sorting(orderBy,sortOrder,ctx){
          ctx.showLoader = true
          ctx.selectedFloorAvailableApartments.sort((a,b) => {
            let currentElement = typeof(a[orderBy]) === 'string' ? Number(a[orderBy].replace(/ /g,'')) : a[orderBy]
            let nextElement = typeof(b[orderBy]) === 'string' ? Number(b[orderBy].replace(/ /g,'')) : b[orderBy]
            if(sortOrder === 'desc'){
              if(currentElement < nextElement){
                return 1
              }
              if(currentElement > nextElement){
                return -1
              }
              return 0
            }else{
              if(currentElement > nextElement){
                return 1
              }
              if(currentElement < nextElement){
                return -1
              }
              return 0
            }
          })
          ctx.showLoader = false
          ctx.orderBy = orderBy
          ctx.sortOrder = ctx.sortOrder === 'asc' ? 'desc' : 'asc'
        }
      },
      attachHeader() {
        let flatsHeading = document.querySelector('.js-flats-heading');
        let flatOptions = document.querySelector('.js-flat-options');
        let fixedPosition = document.querySelector('.header').getBoundingClientRect().height;
        let positionY = flatOptions.getBoundingClientRect().y;
        if(positionY <= fixedPosition) {
          flatOptions.style.paddingTop = fixedPosition + 'px';
          // this.isBottom = true;
        } else {
          flatsHeading.classList.remove('_fixed');
          flatOptions.style.paddingTop = 0;
          // this.isBottom = false;
        }
      },
      // helpers & controls
      getIdFromString(string) {
        return parseInt(string.replace(/[^0-9]/g, ''))
      },

      clickSlide(payload) {
        if(this.step === 1) {
          payload < 1 ? this.step = payload : '';
          if(payload === 0) {
            this.$router.push({ path: '/choice-of-apartment/details' })
          }
        } else if(this.step === 2) {
          payload < 2 ? this.step = payload : '';
          if(payload === 1) {
            this.$router.push({ path: '/choice-of-apartment/details', query: {b_number:this.selectedBuilding.number} })
            this.$router.go();
          }
          if(payload === 0) {
            this.$router.push({ path: '/choice-of-apartment/details' })
          }
        }

      },

      addParamsToLocation(params) {
        history.pushState(
          {},
          null,
          this.$route.path +
          '?' +
          Object.keys(params)
            .map(key => {
              return (
                encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
              )
            })
            .join('&')
        )
      },

      getLocationParams() {
        let params = {}

        if (this.selectedBuilding) {
          params['b_number'] = this.selectedBuilding.number
        }

        if (this.selectedBuildingFloor) {
          params['f_number'] = this.selectedBuildingFloor.number
        }

        if (this.selectedApartment) {
          params['a_number'] = this.selectedApartment.number_on_the_floor
        }

        return params
      },

      fetchLocationParams() {
        let query = this.$route.query
        if (query.b_number && !query.f_number) {
          this.setBuilding(parseInt(query.b_number));

          this.step = 1;
          this.addStepContent();
        }

        if(query.b_number && query.f_number) {
          this.setBuilding(parseInt(query.b_number));
          if(this.selectedBuildingAvailableFloors.find(floor => floor.number === parseInt(query.f_number))) {
            this.setFloor(parseInt(query.f_number))
          }

          this.step = 2;
          this.addStepContent();
        }

        if (this.selectedBuilding
          && this.selectedBuildingFloor
          && query.a_number
          && this.selectedFloorAvailableApartments.find(
            apartment => apartment.number_on_the_floor === parseInt(query.f_number)
          )
        ) {
          setTimeout(()=> {
            this.changeStep();
            this.setFloorPlan(parseInt(query.f_number))
          }, 100);
        }
      },

      showFlat() {
        this.step = 0;
        this.hidden = 2;
      },

      changeStep() {
        if (this.step < this.menu[this.menu.length - 1].id) this.step = this.step + 1;
        if (this.step <= this.menu[this.menu.length - 2].id) this.hidden = this.step - 1;

        this.addStepContent();

        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      },

      addStepContent() {
        switch (this.step) {
          case 1:
              this.removeBuilding()
              this.addBuilding('/images/purchase/building_' + this.selectedBuilding.number + '.svg')
              this.addSmallBuildings()
              if(this.isMobile && this.swiper) {
                  this.swiper.slideTo(1, 1000, false)
              }
              break;
          case 2:
              if (this.isMobile) {
                  this.removeSmallBuildings()
                  this.addSmallBuildings()
              }
              if(this.isMobile && this.swiper) {
                  this.swiper.slideTo(2, 1000, false)
              }

              this.removeBuilding()
              this.addSmallBuildingWithFloors('/images/purchase/building_' + this.selectedBuilding.number + '.svg')

              if (this.selectedBuildingFloor.image) {
                  this.addFloorPlan(this.selectedBuildingFloor.image)
              }
        }
      },

      removeFloorPlan() {
        if (this.svgFloorPlanContainer) {
          this.svgFloorPlanContainer.selectAll("*").remove()
        }

        this.selectedApartment = null
      },

      mouseOverFloorPlan(svgFloorPlan) {
        if (this.selectedFloorAvailableApartments.find(apartment =>
          apartment.number_on_the_floor === this.getIdFromString(svgFloorPlan.srcElement.id))
        ) {
          d3.selectAll("#" + svgFloorPlan.srcElement.id)
            .style('opacity', '0.3')
            .style('cursor', 'pointer')
        }
      },

      mouseOutFloorPlan(svgFloorPlan) {
        // if (this.selectedFloorAvailableApartments.find(apartment =>
        //   apartment.number_on_the_floor === this.getIdFromString(svgFloorPlan.srcElement.id)
        //   && apartment.status === 'available')
        // ) {
        //   if (!this.selectedApartment
        //     || (this.selectedApartment
        //       && this.selectedApartment.number_on_the_floor !== this.getIdFromString(svgFloorPlan.srcElement.id))
        //   ) {
        //     d3.selectAll("#" + svgFloorPlan.srcElement.id)
        //       .style('opacity', '0')
        //   }
        // }
      },

      setFloorPlan(apartmentNumberOnTheFloor) {
        if (this.selectedFloorAvailableApartments.find(apartment =>
          apartment.number_on_the_floor === apartmentNumberOnTheFloor
          && apartment.status === 'available')
        ) {
          if (this.selectedApartment) {
            d3.selectAll("#apartment_" + this.selectedApartment.number_on_the_floor)
              .style('opacity', '0')
              .attr('selected', false)
          }

          this.selectedApartment = this.selectedFloorAvailableApartments
            .find(apartment => apartment.number_on_the_floor === apartmentNumberOnTheFloor)

          this.addParamsToLocation(this.getLocationParams())

          d3.selectAll("#apartment_" + apartmentNumberOnTheFloor)
            .attr('selected', true)
            .style('opacity', '0.3')
        }
      },

      clickOnTheFloorPlan(svgFloorPlan) {
        let apartmentNumberOnTheFloor = this.getIdFromString(svgFloorPlan.srcElement.id)
        if (this.selectedFloorAvailableApartments.find(apartment =>
          apartment.number_on_the_floor === apartmentNumberOnTheFloor
          && apartment.status === 'available')
        ) {
          let apartmentNum = this.selectedFloorAvailableApartments.find(apartment =>
            apartment.number_on_the_floor === apartmentNumberOnTheFloor).id;
          this.$router.push('/choice-of-apartment/selected/' + apartmentNum)
        }
      },

      // buildings logic
      addBuildings(link) {
        let that = this

        d3.svg(link).then(function (xml) {
          d3.select(that.$refs['buildings-container']).node().appendChild(xml.documentElement);
          that.svgBuildingsContainer = d3.select(that.$refs['buildings-container'])
          that.svgBuildings = that.svgBuildingsContainer.selectAll("path[id*='building_selected_']")
            .style("opacity", "0")
            .style("pointer-events", "all")
            .attr('selected', false)
            .on("mouseover", that.mouseOverBuilding)
            .on("mouseout", that.mouseOutBuilding)
            .on('mousedown', that.clickOnTheBuilding)


          // //TEMP ONLY 3RD IS AVAILABLE
          // that.selectedBuilding = that.buildings
          //   .find(building => building.number === 3)
          // //TEMP ONLY 3RD IS AVAILABLE

          if (that.selectedBuilding) {
            console.log('that.selectedBuilding = ',that.selectedBuilding);

            Array.from(that.selectedBuilding).forEach((item)=>{
              that.svgBuildingsContainer.selectAll("path[id='building_selected_" + item.number + "']")
                .attr('selected', true)
                .style('opacity', '1')
                // .style('fill', 'red')
            });
          }
          if (that.buildings) {
            console.log('that.buildings = ',that.buildings);

            Array.from(that.buildings).forEach((item)=>{
              console.log('that.selectedBuilding 1 item',item);
              console.log('that.selectedBuilding 2 item.number',item.number);
              that.svgBuildingsContainer.selectAll("path[id='building_selected_" + item.number + "']")
                .attr('selected', true)
                .style('opacity', '1')
                // .style('fill', 'red')
            });
          }
        });
      },

      removeBuilding() {
        if (this.svgCurrentBuildingContainer) {
          this.svgCurrentBuildingContainer.selectAll("*").remove()
        }

        if (this.step === 1) {
          this.selectedBuildingFloor = null
        }
      },

      removeSmallBuilding() {
        if (this.svgSmallBuildingWithFloorsContainer) {
          this.svgSmallBuildingWithFloorsContainer.selectAll("*").remove()
        }

        this.selectedBuildingFloor = null
      },

      removeSmallBuildings() {
        if (this.svgSmallBuildingsContainer) {
          this.svgSmallBuildingsContainer.selectAll("*").remove()
        }
      },

      addSmallBuildings() {
        let that = this
        setTimeout(()=> {
          if(that.$refs['small-buildings-container']) {
            d3.svg('/images/purchase/buildings.svg').then(function (xml) {
              if(d3.select(that.$refs['small-buildings-container']).node().children.length === 0) {
                d3.select(that.$refs['small-buildings-container']).node().appendChild(xml.documentElement);
                that.svgSmallBuildingsContainer = d3.select(that.$refs['small-buildings-container'])
                that.svgSmallBuildings = that.svgSmallBuildingsContainer.selectAll("path[id*='building_selected_']")
                  .style("opacity", "0")
                  .style("pointer-events", "all")
                  .attr('selected', false)
                // .on("mouseover", that.mouseOverBuilding)
                // .on("mouseout", that.mouseOutBuilding)
                // .on('mousedown', that.clickOnTheBuilding)

                // console.log('that.selectedBuilding 401 = ',that.selectedBuilding)
                if (that.selectedBuilding) {
                // console.log('that.selectedBuilding 402 = ', that.selectedBuilding.number)
                 // Array.from(that.selectedBuilding.find(building => building.number === that.selectedBuilding.number)).forEach((item)=>{
                 //    that.svgSmallBuildingsContainer.selectAll("path[id='building_selected_" + item.number + "']")
                 //      .attr('selected', true)
                 //      .style('opacity', '1')
                 //      .style('fill', 'pink')
                 //      // .style('opacity', '1')
                 //  })

                    that.svgSmallBuildingsContainer.selectAll("path[id='building_selected_" + that.selectedBuilding.number + "']")
                      .attr('selected', true)
                      .style('opacity', '1')
                      // .style('opacity', '1')
                }
              }
            });
          }
        },200)

      },

      mouseOverBuilding(svgBuilding) {

        // if (this.buildings.find(building =>
        //   building.number === this.getIdFromString(svgBuilding.srcElement.id)
        //   && building.available_apartments !== 0)
        // ) {
        //   d3.selectAll("#" + svgBuilding.srcElement.id)
        //     .style('opacity', '1')
        //     .style('cursor', 'pointer')
        // }

        //TEMP ONLY 3RD IS AVAILABLE
        // if (this.selectedBuilding) {
        //   this.svgBuildingsContainer.selectAll("path[id='building_selected_" + this.selectedBuilding.number + "']")
        //     .style('cursor', 'pointer')
        // }
        if (this.buildings) {
          Array.from(this.buildings).forEach(item => {
            console.log('-------1109 number',item.number)
            this.svgBuildingsContainer.selectAll("path[id='building_selected_" + item.number + "']")
              .style('cursor', 'pointer')
          })
        }
      },

      mouseOutBuilding(svgBuilding) {
        //TEMP ONLY 3RD IS AVAILABLE
        // if (this.buildings.find(building =>
        //   building.number === this.getIdFromString(svgBuilding.srcElement.id)
        //   && building.available_apartments !== 0)
        // ) {
        //   if (!this.selectedBuilding
        //     || (this.selectedBuilding
        //       && this.selectedBuilding.number !== this.getIdFromString(svgBuilding.srcElement.id))
        //   ) {
        //     d3.selectAll("#" + svgBuilding.srcElement.id)
        //       .style('opacity', '0')
        //   }
        // }
      },

      setBuilding(buildingNumber) {
        if (this.buildings.find(building =>
          building.number === buildingNumber
          && building.available_apartments !== 0)
        ) {
          if (this.selectedBuilding) {
            d3.selectAll("#building_selected_" + this.selectedBuilding.number)
              .style('opacity', '0')
              .attr('selected', false)
          }

          this.selectedBuilding = this.buildings
            .find(building => building.number === buildingNumber)

          // console.log('this---selecte', this.selectedBuilding)

          d3.selectAll("#building_selected_" + buildingNumber)
            .attr('selected', true)
            .style('opacity', '1')
            // .style('opacity', '1')

          if (this.step === 1) {
            this.removeBuilding()
            this.addBuilding('/images/purchase/building_' + this.selectedBuilding.number + '.svg')
          }

          if (this.step === 2) {
            this.removeFloorPlan()
            this.removeSmallBuilding()
            this.addSmallBuildingWithFloors('/images/purchase/building_' + this.selectedBuilding.number + '.svg')

            if (this.selectedBuildingAvailableFloors[0]) {
              this.selectedBuildingFloor = this.selectedBuildingAvailableFloors[0]
            }
          }

          this.addParamsToLocation(this.getLocationParams())
        }
      },

      clickOnTheBuilding(svgBuilding) {
        let buildingNumber = this.getIdFromString(svgBuilding.srcElement.id)

        this.setBuilding(buildingNumber)
        if (this.step === 0) {
          this.changeStep();
        }
      },

      // Floor logics
      floorIsAvailable(number) {
        return this.selectedBuildingAvailableFloors.find(floor =>
          floor.number === number)
      },

      // building with floors
      addBuilding(link) {
        let that = this
        setTimeout(()=> {
          if (that.$refs['building-container']) {
            d3.svg(link).then(function (xml) {
              d3.select(that.$refs['building-container']).node().appendChild(xml.documentElement);
              that.svgCurrentBuildingContainer = d3.select(that.$refs['building-container'])

              that.svgCurrentBuildingContainer.select('svg')
                .on('mouseleave', that.mouseOutFloorBuilding)
                .style("pointer-events", "auto")

              that.svgCurrentBuilding = that.svgCurrentBuildingContainer.selectAll("path[id*='floor_']")
                .style("opacity", "0")
                .style("pointer-events", "auto")
                .attr('selected', false)
                // .on("mouseover", that.mouseOverFloor)
                .on("mouseover", that.mouseOverFloor)
                .on("mouseout", that.mouseOutFloor)
                .on('mousedown', that.clickOnTheFloor)

              that.mouseOutFloorBuilding()
            });
          }
        },200)
      },

      mouseOutFloorBuilding() {
        if (this.isMobile) {
            const awaitNumber = this.selectedBuildingFloor ? this.selectedBuildingFloor.number : this.chooseRandomFloor();
            this.svgCurrentBuildingContainer.selectAll("path[id*='floor_']")
              .attr('selected', false)
              .style('opacity', '0')
            // this.svgCurrentBuildingContainer.selectAll("path[id='floor_" + this.selectedBuildingFloor.number + "']")
            this.svgCurrentBuildingContainer.selectAll("path[id='floor_" + awaitNumber + "']")
              .attr('selected', true)
              .style('opacity', '1')
            return;
        }
        console.log('mouseOutFloorBuilding')
        let that = this

        that.svgCurrentBuilding.each(function(d,i) {
          const floorNumber = that.getIdFromString(this.id)
          const floorIndex = that.selectedBuildingAvailableFloors.findIndex(floor => {
            return (floor.number === floorNumber) && floor.available_apartments
          })

          if (floorIndex !== -1) {
            d3.select('#' + this.id)
              .style('opacity', '1')
          }
        });
      },
      // small building with floors
      addSmallBuildingWithFloors(link) {
        let that = this

        d3.svg(link).then(function (xml) {
          d3.select(that.$refs['small-building-container']).node().appendChild(xml.documentElement);
          that.svgSmallBuildingWithFloorsContainer = d3.select(that.$refs['small-building-container'])
          that.svgSmallBuildingWithFloors = that.svgSmallBuildingWithFloorsContainer.selectAll("path[id*='floor_']")
            .style("opacity", "0")
            .style("pointer-events", "all")
            .attr('selected', false)
            .on("mouseover", that.mouseOverFloor)
            .on("mouseout", that.mouseOutSmallBuildingWithFloor)
            .on('mousedown', that.clickOnTheFloor)

          if (that.selectedBuildingFloor) {
            that.svgSmallBuildingWithFloorsContainer.selectAll("path[id='floor_" + that.selectedBuildingFloor.number + "']")
              .attr('selected', true)
              .style('opacity', '1')
          }
        });
      },

      setFloor(floorNumber) {
        // console.log('setFloor')
        if (this.floorIsAvailable(floorNumber)) {
          if (this.selectedBuildingFloor) {
            d3.selectAll("#floor_" + this.selectedBuildingFloor.number)
              .style('opacity', '0')
              .attr('selected', false)
          }

          this.selectedBuildingFloor = this.selectedBuilding.floors.find(floor => floor.number === floorNumber);

          d3.selectAll("#floor_" + this.selectedBuildingFloor.number)
              .attr('selected', true)
              .style('opacity', '1');
          if (!(this.step === 1 && this.isMobile)) {
          // if (!(this.step === 1 && this.isMobile) && !this.floorChangeEvent) {
            this.addParamsToLocation(this.getLocationParams());
          }
          // this.addParamsToLocation(this.getLocationParams());
          this.removeFloorPlan();

          if (this.step === 2 && this.selectedBuildingFloor.image) {
            this.addFloorPlan(this.selectedBuildingFloor.image)
          }

          if(this.step === 1 && !this.floorChangeEvent) {
            if (this.isMobile) {
              this.addParamsToLocation(this.getLocationParams());
            }
            this.changeStep();
          }
        }
      },

      chooseRandomFloor() {
        let floor = this.selectedBuildingAvailableFloors[0];
        let floorNumber = floor.number || null;

          setTimeout(() => {
              this.setFloor(floorNumber);
          }, 300);
      },

      clickOnTheFloor(svgFloor) {
        let floorNumber = this.getIdFromString(svgFloor.srcElement.id)
        this.floorChangeEvent = false;
        this.setFloor(floorNumber)

      },

      btnChangeFloor(direction) {
        let currentIndex = this.selectedBuildingAvailableFloors.indexOf(this.selectedBuildingFloor)
        this.floorChangeEvent = true;
        if (direction === 'up') {
          this.setFloor(this.selectedBuildingAvailableFloors[++currentIndex % this.selectedBuildingAvailableFloors.length].number)
        } else {
          this.setFloor(this.selectedBuildingAvailableFloors[
          (currentIndex !== 0
            ? --currentIndex
            : currentIndex = this.selectedBuildingAvailableFloors.length - 1)
          % this.selectedBuildingAvailableFloors.length].number)
        }
      },

      mouseOverFloor(svgFloor) {
        if (this.isMobile) {
          return;
        }
        // let floorNumber = this.getIdFromString(svgFloor.srcElement.id);
        // let floorsHover = []

        // console.log('-------1101 this.selectedBuilding = ',this.selectedBuilding)
        // for (let item of this.selectedBuilding) {
        //   floorsHover = [...item.floors]
        // }

        // this.hoveredBuildingFloor = floorsHover.find(floor => floor.number === floorNumber)

        let floorNumber = this.getIdFromString(svgFloor.srcElement.id);
        this.hoveredBuildingFloor = this.selectedBuilding.floors.find(floor => floor.number === floorNumber)

        if(this.selectedBuildingFloor) {
          console.log('--------1201 this.selectedBuildingFloor = ',this.selectedBuildingFloor)
          console.log('--------1202 this.svgCurrentBuildingContainer = ',this.svgCurrentBuildingContainer)
          this.svgCurrentBuildingContainer.selectAll("path[id*='floor_']")
            .attr('selected', false)
            .style('opacity', '0')

          this.svgCurrentBuildingContainer.selectAll("path[id='floor_" + this.selectedBuildingFloor.number + "']")
            .attr('selected', true)
            .style('opacity', '1')
        }

        if (this.floorIsAvailable(floorNumber)) {
          this.svgCurrentBuildingContainer.selectAll("path[id*='floor_']")
            .attr('selected', false)
            .style('opacity', '0')

          d3.selectAll("#" + svgFloor.srcElement.id)
            .style('opacity', '1')
            .style('cursor', 'pointer')
        }
      },

      mouseOutFloor(svgFloor) {
        let floorNumber = this.getIdFromString(svgFloor.srcElement.id);

        this.hoveredBuildingFloor = null;

        //
        // if (this.floorIsAvailable(floorNumber)) {
        //   if (!this.selectedBuildingFloor
        //     || (this.selectedBuildingFloor
        //       && this.selectedBuildingFloor.number !== floorNumber
        //     )
        //   ) {
        //     d3.selectAll("#" + svgFloor.srcElement.id)
        //       .style('opacity', '0')
        //   }
        // }
      },

      mouseOutSmallBuildingWithFloor(svgFloor) {
        let floorNumber = this.getIdFromString(svgFloor.srcElement.id);

        this.hoveredBuildingFloor = null;


        if (this.floorIsAvailable(floorNumber)) {
          if (!this.selectedBuildingFloor
            || (this.selectedBuildingFloor
              && this.selectedBuildingFloor.number !== floorNumber
            )
          ) {
            d3.selectAll("#" + svgFloor.srcElement.id)
              .style('opacity', '0')
          }
        }
      },
    },
    computed: {
      swiper() {
        return this.$refs.swiper.$swiper
      },
      isMobile() {
        return window.innerWidth < 1024
      },
      isIpadOS() {
        return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
      },
      showApartmentObject() {
        let result = {path: '/choice-of-apartment/selected'}

        if (this.selectedApartment) {
          result.path += '/' + this.selectedApartment.number
        }

        return result
      },
      btnAvailable() {
        switch (this.step) {
          case 0:
            return this.selectedBuilding;
            break;
          case 1:
            return this.selectedBuildingFloor;
            break;
          case 2:
            return this.selectedApartment;
            break;
        }
      },
      selectedBuildingAvailableFloors() {
        if (!this.selectedBuilding) return null

        if (this.selectedBuilding.length > 1) {
          let floors =  new Array();

          // console.log('--------this.selectedBuilding',this.selectedBuilding);
          for(let item of this.selectedBuilding) {
            floors = [...item.floors]
          }
          // console.log('floors----', floors);
          return floors;
        }
        return this.selectedBuilding.floors.filter(floor => floor.available_apartments)
      },
      selectedBuildingAvailableApartments() {
        if (!this.selectedBuilding) return null

        return this.selectedBuilding.floors
          .filter(floor => floor.available_apartments !== 0)
          .map(floor => floor.apartments.filter(aparment => aparment.status === 'available'))
          .reduce(function (pre, cur) {
            return pre.concat(cur);
          })
      },
      selectedFloorAvailableApartments: {
        get: function () {
          if (!this.selectedBuildingFloor) return null
          return this.selectedBuildingFloor.apartments.filter(apartment => apartment.status === 'available').sort((a,b)=>{
            if(Number(a.area) < Number(b.area)){
              return -1
            }else{
              return 1
            }
            return 0
          })
        },
        set: function(newVal){
          this.selectedBuildingFloor = newVal
        }

      }
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../sass/variables';

  .swiper-slide {
    font-weight: 800;
    font-size: 1.4rem;
    /*letter-spacing: 0.16em;*/
    line-height: 1.5;
    text-transform: uppercase;
    height: 3.7rem;

    &._active {
      color: $hypertext;
      position: relative;

      &::after {
        content: '';

        position: absolute;

        left: 0;
        bottom: 0;

        width: 8.8rem;
        height: 0.1rem;

        background: $hypertext;
      }
    }
  }

  .flat {
    &.relative {
      @media (min-width: $desktop-min-width) {
        min-height: 100%;
        padding-top: 1px;
        padding-bottom: 1px;
      }
    }
    &-choose__icon {
      width: 1.6rem;
      height: 1.6rem;

        &._arrow {
          width: 1.7rem;
          height: 1.7rem;
        }
    }

    &-detailed {

      &.last-step {
        @media (min-width: $desktop-min-width) {
          width: 62rem;
          margin-top: 15.2rem;
          /*margin: 7.2rem 14rem 7.9rem 14rem;*/
          margin-bottom: 18.8rem;
        }
      }

      @media (min-width: $desktop-min-width) {
        min-height: 50rem;
        width: 52rem;
        margin: 7.2rem 14rem 7.9rem 7rem;

        &.w-unset {
          width: unset;
        }
      }

      &__scheme-coloured {
        width: 49.2rem;
        height: auto;
        margin-top: 2.4rem;
        margin-right: 1.2rem;
        margin-bottom: 5.7rem;
        @media (min-width: $desktop-min-width) {
          margin-top: 5.1rem;
          margin-right: 0;
          margin-bottom: 0;
        }
      }

      &__title {
        margin-top: 3.4rem;
        margin-left: 2.4rem;
        margin-bottom: 1.6rem;

        letter-spacing: 0.07em;

        @media (min-width: $desktop-min-width) {
          margin-left: 0;
          margin-top: 0;
          margin-bottom: 1.3rem;
        }

        & svg {
          transform: rotate(180deg);
          margin-right: 2.6rem;
          width: 1.8rem;
          height: 1.8rem;
        }
      }

      &__subtitle {
        margin-bottom: 4.6rem;

        font-size: 2.4rem;
        letter-spacing: 0.07em;
        line-height: 1.5;
        font-weight: 700;

        &._multiple {
          margin-bottom: 1.1rem;

          @media (min-width: $desktop-min-width) {
            margin-bottom: 0;
          }

          &._floor {
            margin-bottom: 3.3rem;

            @media (min-width: $desktop-min-width) {
              margin-bottom: 4.6rem;
            }
          }

          &._flat {
            margin-bottom: 4.5rem;
          }
        }
      }

      &__step {
        margin-left: 2.4rem;
        margin-right: 1.2rem;

        &._second {
          padding-top: 1rem;
        }

        @media (min-width: $desktop-min-width) {
          margin-left: 0;
        }
      }

      &__forward-btn {
        width: 100%;
        padding: 1.8rem;

        font-weight: 800;
        letter-spacing: 0.16em;
        font-size: 1.4rem;
        line-height: 1.5;
        background: #ffffff;
        border: none;
        cursor: pointer;

        outline: none;


        & svg {
          width: 1.8rem;
          height: 1.8rem;
          margin-left: 1.4rem;
        }

        @media (min-width: $desktop-min-width) {
          width: fit-content;
          padding: 0;

          background: transparent;
        }
      }

      &__buildings-small {
        margin-bottom: 1.6rem;
        margin-right: 1.2rem;

        & img {
          display: block;
          width: 100%;
        }

        & #buildings {
          display: block;
          width: 22rem;
          height: 12rem;
          pointer-events: none;
        }
      }

      &__buildings-big {
        margin-bottom: 3.5rem;

        & img {
          display: block;
          width: 23.1rem;
          height: 29.9rem;
          margin: 0 auto;
        }

        #buildings-container {
          display: block;
          width: 23.1rem;
          height: 29.9rem;
          margin: 0 auto;
          pointer-events: none;
        }

        & #buildings {
          display: block;
          width: 22rem;
          height: 12rem;
          pointer-events: none;
        }
      }

      &__available {
        /*margin-bottom: 1.8rem;*/
        font-weight: 800;
        font-size: 1.4rem;
        letter-spacing: 0.16em;

        & ._hypertext {
          color: $hypertext;
        }
      }

      &__plan {
        margin-left: 2.4rem;
        margin-bottom: 3.2rem;

        font-size: 1.2rem;
        line-height: 1.5;
        font-weight: 800;
        text-align: center;
        text-transform: uppercase;
        border: none;
        letter-spacing: 0.16em;

        outline: none;

        & .arrow-icon {
          width: 1.7rem;
          height: 1.7rem;
        }

        @media (min-width: $desktop-min-width) {
          margin-bottom: 3.2rem;
          margin-left: 0;
        }
      }

      &-description {
        margin-bottom: 1.5rem;
        font-size: 1.4rem;
        line-height: 1.5rem;

        &__point {
          margin-bottom: 0.5rem;
        }
      }
    }

    &-plans {
      @media (min-width: $desktop-min-width) {
        position: absolute;

        // bottom: unset;
        bottom: 0;
        top: 0;
        right: 4.4rem;

        display: flex;
        align-items: center;
        /*padding-top: 8rem;*/

        &__row {
          display: flex;
          width: 100%;
          flex: 0 0 100%;
          max-width: 100%;
          min-height: 1px;
        }

        &__image {
          &._buildings {
            margin-right: 21.2rem;
            margin-top: 4rem;

            & img {
              width: 39.8rem;
              height: 51.5rem;
            }

            & #buildings-container {
              width: 39.8rem;
              /*height: 51.5rem;*/
              height: 44.6rem;
              pointer-events: none;

              & svg {
                width: 100%;
                height: auto;
              }
            }
          }

          &._scheme {

            & img {
              width: 100%;
              height: 100%;
            }
          }

          &._building {
            margin-right: 7.7rem;
            margin-top: 2.1rem;

            & img {
              width: 28.6rem;
              height: 50.1rem;
            }

            & #building-container {
              pointer-events: none;
              width: 28.6rem;
              height: 50.1rem;
            }
          }

          &._buildings-small {
            margin-right: 5.6rem;
            margin-bottom: 5.2rem;

            &._big-margin {
              margin-right: 8.1rem;
            }

            & img {
              width: 9.3rem;
              height: 12rem;
              margin-bottom: 1rem;
            }

            & #small-buildings-container {
              pointer-events: none;
              width: 9.3rem;
              height: 12rem;
              margin-bottom: 1rem;
            }
          }

          &._building-small {
            /*margin-right: 5.6rem;*/
            margin-bottom: 5.5rem;
            margin-top: 3.8rem;

            & #small-building-container {
              width: 12.3rem;
              height: 22rem;
              pointer-events: none;
              margin: 0 auto;
            }

            & img {
              width: 100%;
              height: 100%;
            }

            & .flat-control {
              right: 18rem;
              bottom: 16rem;
            }
          }

          &._flats-plan {
            margin-right: 7.7rem;
            margin-top: 20rem;

            & #floor-plan {
              pointer-events: none;
              width: 45rem;
              height: 28rem;
            }

            & img {
              width: 45rem;
              height: 28rem;
            }

          }
        }

        &-description {
          right: -11.4rem;
          top: 14rem;

          &__text {
            margin-bottom: 0.3rem;
            color: $hypertext;
            letter-spacing: 0.16em;
          }
        }
      }
    }

    &-menu {
      list-style: none;
      padding: 0;
      display: flex;
      margin-bottom: 3.2rem;
      margin-left: 2.4rem;
      margin-right: 1.2rem;

      @media (min-width: $desktop-min-width) {
        margin-bottom: 5rem;
        margin-left: 0;

      }

      &__item {
        font-weight: 800;
        font-size: 1.4rem;
        /*letter-spacing: 0.16em;*/
        line-height: 1.5;

        &._active {
          color: $hypertext;
          position: relative;

          &::after {
            content: '';

            position: absolute;

            left: 0;
            bottom: -1.6rem;

            width: 8.8rem;
            height: 0.1rem;

            background: $hypertext;
          }
        }

        &._hidden-mobile {
          display: none;

          @media (min-width: $desktop-min-width) {
            display: block;
          }
        }
      }
    }

    &-options {
      line-height: 1.5;
      font-weight: 800;
      color: $textAndBorder;
      max-height: 35rem;
      overflow: hidden;
      overflow-y: scroll;

      @media (min-width: $desktop-min-width) {
        margin-bottom: 4rem;
      }

      &._flats {
        margin-bottom: 4rem;
      }
    }

    &-overview {
      margin-bottom: 3.5rem;
      user-select: none;

      &__building {
        #building-container {
          width: 17.8rem;
          height: 31.6rem;
          pointer-events: none;
        }

        & img {
          width: 17.8rem;
          height: 31.6rem;
        }
      }

      &-description {
        top: 13rem;
        right: -13rem;

        &__text {
          margin-bottom: 0.3rem;

          color: $hypertext;
          letter-spacing: 0.16em;
          font-weight: 800;
        }
      }

      &-buildings {
        margin-right: 0.9rem;
        /*margin-top: 2rem;*/
        cursor:pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

        &__choose-item {
          & svg {
            width: 1.7rem;
            height: 1.7rem;
            transform: rotate(180deg);
          }

          &._flat {
            margin-bottom: 1.9rem;
            @media (min-width: $desktop-min-width) {
              margin-bottom: 3.2rem;
            }
          }
        }

        #small-buildings-container {
          width: 6.3rem;
          height: 8.2rem;
          margin-bottom: 0.7rem;
          pointer-events: none;
        }

        & img {
          width: 6.3rem;
          height: 8.2rem;
          margin-bottom: 0.7rem;
        }

      }
    }

    &-scheme {
      margin-right: 0.9rem;
      margin-bottom: 2.3rem;

      &__floor {
        #floor-plan {
          width: 22.6rem;
          height: 15.3rem;
          pointer-events: none;
        }

        & img {
          width: 22.6rem;
          height: 15.3rem;
        }
      }

      &__control {
        background: transparent;
        border: none;
        outline: none;
        cursor: pointer;
        /*padding: 1.5rem;*/

        &._up {
          transform: rotate(-90deg);
          margin-bottom: 1.3rem;

          & svg {
            width: 0.4rem;
            height: 1rem;
          }
        }


        &._down {
          transform: rotate(90deg);
          margin-bottom: 0.4rem;

          & svg {
            width: 0.4rem;
            height: 1rem;
          }
        }

        & svg {
          width: 0.7rem;
          height: 1.4rem;
        }
      }

      &-floor {
        &__number {
          margin-bottom: 0.7rem;
          font-size: 3.8rem;
          line-height: 1.5;
          font-weight: 800;
          letter-spacing: 0.07em;
        }

        &__text {
          margin-bottom: 2.6rem;
        }
      }
    }

    &-options {
      height: unset;
      overflow: auto;
      line-height: 1.5;
      font-weight: 800;
      color: $textAndBorder;

      @media (min-width: $desktop-min-width) {
        height: unset;
        font-size: 1.4rem;
      }

      &._options-open {
        order: 4;
      }

      &-heading {
        font-weight: 400;
        padding-bottom: 1.4rem;
        padding-top: 3.6rem;
        position: sticky;
        top: -0.2rem;
        /*background: #ffffff;*/
        border-bottom: 0.1rem solid #C6C6C6;

        @media (min-width: $desktop-min-width) {
          background: #FFFBF8;
        }

        &__text{
          cursor: pointer;
          &.desc{
            position: relative;
            &::after{
              content: '';
              position: absolute;
              left: 100%;
              top: 50%;
              width: 0;
              height: 0;
              border-left: 5px solid transparent;
              border-right: 5px solid transparent;
              border-top: 5px solid #000;
              clear: both;
              margin-left: 4px;
              margin-top: -2px;
            }
          }

          &.asc {
            position: relative;
            &::after {
              content: '';
              position: absolute;
              left: 100%;
              top: 50%;
              width: 0;
              height: 0;
              border-left: 5px solid transparent;
              border-right: 5px solid transparent;
              border-bottom: 5px solid #000;
              clear: both;
              margin-left: 4px;
              margin-top: -2px;
            }
          }
        }
      }
    }
  }

  .rose {
    width: 17rem;
    height: auto;
    margin-top: -2rem;
    margin-bottom: 8.5rem;

    & img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .back-btn {
    width: fit-content;
    border:none;
    outline: none;
    background: transparent;
    font-weight: 700;
    font-size: 1.4rem;
    padding: 1rem;
    margin-top: 0.8rem;
    margin-bottom: 7.2rem;
    line-height: 1.5;
    color: $textAndBorder;

    & svg {
      width: 1.7rem;
      height: 1.7rem;

      transform: rotate(180deg);
    }
  }
</style>
